import close from "../assets/close.svg";
import Button from "../framework/Button.js";

const Popup = ({id, title, messageBold, messageNormal, buttonList}, props) => {
    let i = 0;
    return (
        <div id={id} className="overlay popup--overlay">
            <div className="popup popup--layer">
                <div className="popup--header">
                    <div
                        className="popup--header-title"
                        id={id + "_components_" + i++}
                    >
                        {title}
                    </div>
                    <div className="popup--header-close">
                        <a href="#/" id={id + "_components_" + i++}
                              onClickFunction={ (e) => { e.preventDefault(); window.location.href = "#";
                                    window.history.replaceState( null, document.title, window.location.href.split("#")[0]); }}
                                >
                            <span className="popup--header-close-txt">Close</span>{" "}
                            <img src={close} alt="Close Menu"/>
                        </a>
                    </div>
                </div>
                <div className="popup--content" id={id + "_components_" + i++}>
                    {messageBold !== undefined && messageBold.length > 0 && (
                        <span className="semi-bold">{messageBold}&nbsp;</span>
                    )}
                    {messageNormal !== undefined &&
                    messageNormal.length > 0 &&
                    <div dangerouslySetInnerHTML={{__html: messageNormal}}/>}
                </div>

                <div className="popup--buttons">
                    {buttonList !== undefined && buttonList.length > 0 && (
                        buttonList.map((button) =>
                            <Button
                                id={button.id}
                                text={button.text}
                                styleName={button.style}
                                    onClick={ (e) => { button.eventHandler(); e.preventDefault(); window.location.href = "#";
                                    window.history.replaceState( null, document.title, window.location.href.split("#")[0]); }}
                            />
                        ))
                    }
                </div>

            </div>
        </div>
    );
};

export default Popup;

